import AutoSymptom from './src/main'

AutoSymptom.install = function (Vue) {
    Vue.component(AutoSymptom.name, AutoSymptom)
}

export default AutoSymptom